module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.4-256.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.6.4.md
// module id = 699
// module chunks = 256